// extracted by mini-css-extract-plugin
module.exports = {"container":"DefectTypeFilter_container__2SvrS","content":"DefectTypeFilter_content__dKMUZ","users":"DefectTypeFilter_users__1L-iD"};